import React from 'react';
import { Link } from 'react-router-dom';
import LoginButton from '../components/LoginButton';
import TopBody from '../components/TopBody';
import VacancyListBlock from '../components/VacancyListBlock';
import RecsiteAPI from '../service/RecsiteAPI';
import Select from '../components/Vacancies/Select';
import './Vacancies.css';
import config from '../config/constants';
import PoweredBy from '../components/PoweredBy';
import IFrameService from '../service/IFrameService';

export default class Vacancies extends React.Component {
	
	state = {
		showMoreOptions: false,
		category: 'All',
		pages: {},
		
		// TODO: Remove this example on life
		// vacancies: [{
		// 	id: 1,
		// 	name: 'Chef',
		// 	salary_level: {
		// 		id: 1,
		// 		name: '6 p/h'
		// 	}
		// }],
		vacancies: [],
		filters: {
			keyword: '',
			sortBy: 'date',
			industryId: 0,
			subIndustryId: 0,
			locationId: 0,
			salaryTypeId: 0,
			postedAtId: 0,
			limit: 1000
		},
		industries: [],
		locations: [],
		salaryTypes: [], // hours
		sortByItems: [
			{ id: 'date', name: 'Date' },
			{ id: 'location', name: 'Location' },
			{ id: 'position', name: 'Job Position' }
		],
		postedAt: [
			{ id: 0, name: 'Any Time' },
			{ id: 1, name: 'Today' },
			{ id: -7, name: 'Last 7 Days' },
			{ id: -14, name: 'Last 14 Days' },
			{ id: -30, name: 'Last 30 Days' },
			{ id: -90, name: 'Last 3 Months' },
			{ id: -180, name: 'Last 6 Months' }
		]
	};
	
	// TODO: move sort by into component
	componentDidMount = () => {
		let filters = {
			limit: this.state.filters.limit
		};
		if (this.props.match.params.category) {
			const categoryName = this.props.match.params.category;
			filters = {
				industryId: config[categoryName].INDUSTRY_ID,
				subIndustryId: config[categoryName].SUB_INDUSTRY_ID,
				limit: this.state.filters.limit
			};
		}
		
		RecsiteAPI.getVacancies(filters).then(data => {
			const vacancies = data.data.map(row => row.attributes);
			this.setState({
				vacancies: vacancies,
				pages: data.meta
			})
		});
		RecsiteAPI.getIndustries().then(data => {
			const first = [{ id: 0, name: 'Any Sector' }];
			const industries = first.concat(data);
			this.setState({ industries })
		});
		RecsiteAPI.getLocations().then(data => {
			const first = [{ id: 0, name: 'Any Location' }];
			const locations = first.concat(data);
			this.setState({ locations })
		});
		RecsiteAPI.getSalaryTypes().then(data => {
			const first = [{ id: 0, name: 'Any Type' }];
			const salaryTypes = first.concat(data);
			this.setState({ salaryTypes });
		});
	};
	
	componentDidUpdate = () => {
		IFrameService.parentData();
	};
	
	toggleOptions = () => {
		this.setState({ showMoreOptions: !this.state.showMoreOptions })
	};
	
	getFilteredVacancies = () => {
		RecsiteAPI.getVacancies(this.state.filters).then((data) => {
			const vacancies = data.data.map(row => row.attributes);
			this.setState({
				vacancies: vacancies,
				pages: data.meta
			})
		});
	};
	
	renderFilters = () => {
		
		return (
			<div>
				
				<div className="filters-block filters__first-line">
					
					<div>
						<div className="gfield gfield_genesis">
							{(this.state.filters.keyword === '') && (
								<label className="gfield_label" htmlFor="username">Keyword</label>)}
							<div className="ginput_container">
								<input name="keyword" id="keyword" type="text" value={this.state.filters.keyword} onChange={(event) => {
									this.setState({ filters: { ...this.state.filters, keyword: event.target.value } }, () => this.getFilteredVacancies())
								}}/>
							</div>
						</div>
					</div>
					
					<div className="filters__sort-by">
						<label className="filters__sort-by--label">Sort by:</label>
						<Select
							value={this.state.filters.sortBy}
							options={this.state.sortByItems}
							callback={(sortBy) => {
								this.setState({ filters: { ...this.state.filters, sortBy } }, () => this.getFilteredVacancies())
							}}
						/>
					</div>
					
				</div>{ /* .filters-block filters__first-line */ }
				
				<div>
					<div className="gfield gfield_genesis_more_options_button">
						<button className="btn btn_submit" onClick={() => this.toggleOptions()}>
							<span className="text-outline">More options</span>
							<span className="btn_bg"/>
						</button>
					</div>
				</div>
				
				
				{ this.state.showMoreOptions &&
					(
						<div className="filters-block filters__second-line">
							<div className="filters-inner-block">
								<Select
									value={this.state.filters.industryId}
									options={this.state.industries}
									callback={(industryId) => {
										this.setState({ filters: { ...this.state.filters, industryId } }, () => this.getFilteredVacancies())
									}}
								/>
								
								<Select
									value={this.state.filters.locationId}
									options={this.state.locations}
									callback={(locationId) => {
										this.setState({ filters: { ...this.state.filters, locationId } }, () => this.getFilteredVacancies())
									}}
								/>
							</div>
							
							<div className="filters-inner-block__second">
								<Select
									value={this.state.filters.salaryTypeId}
									options={this.state.salaryTypes}
									callback={(salaryTypeId) => {
										this.setState({ filters: { ...this.state.filters, salaryTypeId } }, () => this.getFilteredVacancies())
									}}
								/>
								
								<Select
									value={this.state.filters.postedAtId}
									options={this.state.postedAt}
									callback={(postedAtId) => {
										this.setState({ filters: { ...this.state.filters, postedAtId } }, () => this.getFilteredVacancies())
									}}
								/>
							</div>
						</div>
					)
				}
				
			</div>
		);
	};
	
	renderVacancies = () => {
		if (this.state.vacancies.length > 0) {
			return this.state.vacancies.map((vacancy, index) => (
					<VacancyListBlock
						key={index}
						vacancyId={vacancy.vacancy_id}
						vacancyName={vacancy.title}
						salary={(vacancy.salary_level) ? vacancy.salary_level.name : ''}
					/>
				)
			);
		}
	};
	
	render = () => {
		
		return (
			<div className="container">
				<LoginButton/>
				<TopBody header={`${this.props.match.params.category ? this.props.match.params.category : 'All'} Jobs`}
				         title={'Vacancies'}/>
				
				{(!this.props.match.params.category) && this.renderFilters()}
				
				<div className="flex-parent rcg-vacancies-section-header">
					<div className="flex-child">
						<h3 className="rcg-small-title text-outline">Current Vacancies</h3>
					</div>
				</div>
				
				<div className="flex-parent vacancies-list-container">
					<div className="flex-child">
						{this.renderVacancies()}
					</div>
				</div>
				
				<div className="flex-parent">
					<div className="flex-child">
						<p className="top-paragraph user-content">
							<Link className="link-outline" title="All jobs" to={`/vacancies`} onClick={() => {
								RecsiteAPI.getVacancies(this.state.filters).then(data => {
									const vacancies = data.data.map(row => row.attributes);
									this.setState({
										vacancies: vacancies,
										pages: data.meta
									})
								});
								window.scrollTo(0, 0);
							}}>Click here</Link> to view all jobs
						</p>
						<p className="bottom-paragraph user-content">
							Don't see the right job for you here. You can quickly and easily <a className="link-outline"
							                                                                       title="Upload your CV"
							                                                                       target="__blank"
							                                                                       href={`${config.PROTOCOL}://${config.DOMAIN}/register`}>upload your CV</a>,
							and we'll contact you when we have a job match
						</p>
					</div>
				</div>
				
				<PoweredBy />
			
			</div>
		);
	};
}


// WEBPACK FOOTER //
// ./src/pages/Vacancies.js